function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Listings",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Results",
  transform: "translate(-530.000000, -165.000000)",
  fill: "#D2D5E4"
}, /*#__PURE__*/React.createElement("g", {
  id: "Content",
  transform: "translate(280.000000, 90.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Results",
  transform: "translate(0.000000, 55.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6"
}, /*#__PURE__*/React.createElement("g", {
  id: 1
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(12.000000, 15.307692)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M246,7.12980769 L244.8424,5.59012019 C244.5712,5.04005769 244.0168,4.69230769 243.4112,4.69230769 L238.8,4.69230769 C238.3576,4.69230769 238,5.05549519 238,5.50480769 L238,16.0673077 C238,16.9643077 238.7168,17.6923077 239.6,17.6923077 L252.4,17.6923077 C253.2832,17.6923077 254,16.9643077 254,16.0673077 L254,8.75480769 C254,7.85780769 253.2832,7.12980769 252.4,7.12980769 L246,7.12980769 Z",
  id: "Fill-110"
}))))))));

var SvgFolder = function SvgFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "13px",
    viewBox: "0 0 16 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Folder.3ec57574.svg";
export { ForwardRef as ReactComponent };